import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import useCurrentSiteTakeover from 'hooks/useCurrentSiteTakeover'
import SiteTakeoverBackgroundImage from './SiteTakeoverBackgroundImage'
import { themeClassName } from 'lib/theme/themeUtils'
import LayoutContainer from '../LayoutContainer'

const Background = styled(SiteTakeoverBackgroundImage)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
`

const Content = styled(Group)`
  transform: translateZ(0);
`

const Banner = styled(Group)`
  padding: ${rem(12)};
  position: relative;

  ${mediaQueryUp.tablet} {
    height: ${rem(154)};
  }
`

function SiteTakeoverSearchBanner() {
  const siteTakeover = useCurrentSiteTakeover()

  if (!siteTakeover) {
    return null
  }

  return <CSSBreakpoint min="tablet">
    <Banner
      direction="horizontal"
      verticalAlign="center"
    >
      <Background background="search"/>
      <LayoutContainer>
        <Content
          direction="horizontal"
          gap={20}
          verticalAlign="center"
          className={themeClassName(siteTakeover.palette)}
        >
          {siteTakeover.searchPageBannerContent}
        </Content>
      </LayoutContainer>
    </Banner>
  </CSSBreakpoint>
}

export default SiteTakeoverSearchBanner
